/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/streaming/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * CollectionStage identifies which stage of a collection a request targets.

 - COLLECTION_STAGE_UNSPECIFIED: Stage not specified.
 - COLLECTION_STAGE_DRAFT: The draft stage.
 - COLLECTION_STAGE_PUBLISHED: The published stage.
 */
export type V1CollectionStage =
  (typeof V1CollectionStage)[keyof typeof V1CollectionStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1CollectionStage = {
  COLLECTION_STAGE_UNSPECIFIED: 'COLLECTION_STAGE_UNSPECIFIED',
  COLLECTION_STAGE_DRAFT: 'COLLECTION_STAGE_DRAFT',
  COLLECTION_STAGE_PUBLISHED: 'COLLECTION_STAGE_PUBLISHED',
} as const;
